/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Reserva_Datos from "../../Formularios/Reservas/Formulario_Reserva_Datos";
import {Delete, DoorFrontOutlined} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import Formulario_Reserva_Valores from "../../Formularios/Reservas/Formulario_Reserva_Valores";
import {useEffect, useState} from "react";
import Selector_Habitacion from "../../../Modulo_Motor_Reservas/Componentes/Selector_Habitacion";
import {FECHACHECKIN, FECHACHECKOUT, ORIGENESRESERVAS} from "../../../Modulo_Motor_Reservas/Constantes";
import {
    obtenerHabitacionesOcupadasEntreFechas
} from "../../../Modulo_Motor_Reservas/Controladores/obtenerHabitacionesOcupadasEntreFechas";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.png"
import {obtenerFechaEstandarCheckOut} from "../../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckOut";
import {obtenerFechaEstandarCheckIn} from "../../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckIn";
import {obtenerHabitaciones} from "../../../Modulo_Motor_Reservas/Controladores/obtenerHabitaciones";
import {obtenerNumNoches} from "../../../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";
import {obtenerValorReserva} from "../../../CodNegocio/obtenerValorReserva";
import {obtenerDoc} from "../../../Servicios/BD/obtenerDoc";
import {obtenerValorReservaAdultos} from "../../../CodNegocio/obtenerValorReservaAdultos";
import {obtenerValorReservaNinos} from "../../../CodNegocio/obtenerValorReservaNinos";
import {obtenerValorSaldo} from "../../../CodNegocio/obtenerValorSaldo";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {adaptador_habitacion_mas_reserva} from "../../Adaptadores/adaptador_habitacion_mas_reserva";

const Dialogo_Reserva = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: {
            fechaCheckOut: new Date().getTime() + 1000 * 60 * 60 * 24,
            numNinos: 0,
            numAcompanantes: 1,
            ...datos
        }
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar, error} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })
    const [habOcupadas, setHabOcupadas] = useState([])
    const [mostrarHabitaciones, setMostrarHabitaciones] = useState(false)
    const [cargando, setCargando] = useState(false)
    const [seleccionada, setSeleccionada] = useState({})
    const [habitaciones, setHabitaciones] = useState([])


    const subirDatos = async () => {

        iniciarCarga('Subiendo datos')
        let entidad = await obtenerEntidad()
        let numNoches = obtenerNumNoches({fechaCheckIn: entidad.fechaCheckIn, fechaCheckOut: entidad.fechaCheckOut})

        entidad.numNoches = parseInt(numNoches)
        if (!seleccionada.id) {
            terminar({aviso: 'No se ha asignado habitacion', variante: 'error'})
            return
        }

        if (entidad.numAcompanantes < 1){
            terminar({aviso: 'El numero minimo de adultos es de 1', variante: 'error'})
            return
        }

        entidad = adaptador_habitacion_mas_reserva({reserva: entidad, habitacion: seleccionada})

        entidad.valor = obtenerValorReserva({entidad: entidad, numNoches: numNoches, habitacion: seleccionada})


        if (!entidad.id) {
            entidad.fecha = new Date().getTime()
        }

        if (!entidad.estado) {
            entidad.estado = 'Reservada'
        }

        if (!entidad.origen) {
            entidad.origen = ORIGENESRESERVAS[0]
        }

        entidad[FECHACHECKIN] = obtenerFechaEstandarCheckIn(entidad[FECHACHECKIN])
        entidad[FECHACHECKOUT] = obtenerFechaEstandarCheckOut(entidad[FECHACHECKOUT])

        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            terminar({aviso: 'Datos subidos correctamente'})
        } else {
            terminar({aviso: 'Algo inesperado paso! datos no subidos', variante: 'error'})
        }


    }


    const borrar = async () => {
        await borrarDoc('reservas', datos.id)
        terminar({aviso: 'Registro borrado'})
    }

    const seleccionarHabitacion = (e) => {

        if (e.numero) {

            let fechaCheckIn = props.getValues(FECHACHECKIN)
            let fechaCheckOut = props.getValues(FECHACHECKOUT)
            let numNoches = obtenerNumNoches({
                fechaCheckIn: obtenerFechaEstandarCheckIn(fechaCheckIn),
                fechaCheckOut: obtenerFechaEstandarCheckOut(fechaCheckOut)
            })


            let numAcompanantes = props.getValues('numAcompanantes')
            let numNinos = props.getValues('numNinos')

            let total = obtenerValorReserva({
                entidad: {numAcompanantes: numAcompanantes, numNinos: numNinos},
                habitacion: e,
                numNoches: numNoches
            })

            props.setValue('valorAdultos', obtenerValorReservaAdultos({
                entidad: {numAcompanantes: numAcompanantes},
                habitacion: e,
                numNoches: numNoches
            }))
            props.setValue('valorNinos', obtenerValorReservaNinos({
                entidad: {numNinos: numNinos},
                habitacion: e,
                numNoches: numNoches
            }))
            props.setValue('numero', e.numero)
            props.setValue('numNoches', numNoches)
            props.setValue('valor', total)
        }
        setSeleccionada(e)
    }


    const buscarDisponibles = async () => {


        let entidad = await obtenerEntidad()
        let fechaCheckIn = entidad[FECHACHECKIN]
        let fechaCheckOut = entidad[FECHACHECKOUT]

        let habs = await obtenerHabitacionesOcupadasEntreFechas({
            fechaCheckIn: fechaCheckIn,
            fechaCheckOut: fechaCheckOut
        })
        setHabOcupadas(habs)
        setMostrarHabitaciones(true)
        setSeleccionada({})


    }

    useEffect(() => {

        if (mostrarHabitaciones || seleccionada.id) {
            setMostrarHabitaciones(false)
            setSeleccionada({})
        }


    }, [props.watch(FECHACHECKIN), props.watch(FECHACHECKOUT), props.watch('numNinos'), props.watch('numAcompanantes')])


    useEffect(() => {
        obtenerHabitaciones().then((dox) => {
            setHabitaciones(dox)
        })
    }, []);


    useEffect(() => {

        if (datos && datos.idHabitacion) {
            obtenerDoc('habitaciones', datos.idHabitacion).then((dox) => {
                if (dox.res) {
                    seleccionarHabitacion(dox.data)
                }
            })
        }

    }, [datos])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva_Datos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 4}}>
                <Button loading={cargando}
                        onClick={() => buscarDisponibles()}
                        variant={'outlined'} startIcon={<DoorFrontOutlined/>}>Ver Habitaciones disponibles</Button>

            </Grid>

            {mostrarHabitaciones &&

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{my: 4}}>
                    <Selector_Habitacion habitaciones={habitaciones} habOcupadas={habOcupadas}
                                         seleccionada={seleccionada} setSeleccionada={seleccionarHabitacion}/>
                </Grid>
            }

            {seleccionada.id &&

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                    <Formulario_Reserva_Valores props={props}/>
                </Grid>

            }

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Reserva